import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaysafeComponent } from "./components/paysafe/paysafe.component";
import { CoreModule } from "../core/core.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CheckoutDepositWebsocketStateService } from "@modules/checkout/services/checkout-deposit-websocket-state.service";

@NgModule({
	declarations: [PaysafeComponent],
	exports: [PaysafeComponent],
	imports: [CommonModule, CoreModule, FormsModule, ReactiveFormsModule],
	providers: [CheckoutDepositWebsocketStateService]
})
export class PaysafeModule {}
